"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryComboGoodsSearch = queryComboGoodsSearch;
exports.queryGoodsAndSpecSearch = queryGoodsAndSpecSearch;
exports.queryGoodsCateoryTree = queryGoodsCateoryTree;
exports.queryGoodsSearch = queryGoodsSearch;
exports.queryMemberLevelList = queryMemberLevelList;
exports.queryMenuType = queryMenuType;
exports.queryMenuTypeByGroupBuy = queryMenuTypeByGroupBuy;
exports.queryOrderType = queryOrderType;
exports.queryRegionStoreList = queryRegionStoreList;
exports.queryThresholdType = queryThresholdType;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var requestUrl = '/xyGaCombo';

// 搜索组合商品
function queryComboGoodsSearch(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/comboGoodsSearch',
    method: 'get',
    params: query
  });
}
// 订单类型
function queryOrderType() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/orderType',
    method: 'get'
  });
}

// 获取商品分类树
function queryGoodsCateoryTree() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/categoryTree',
    method: 'get'
  });
}

// 获取 会员等级
function queryMemberLevelList() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/gradeCombo',
    method: 'get'
  });
}

// 获取店铺
function queryRegionStoreList(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/storeList',
    method: 'get',
    params: query
  });
}

// 点餐类型
function queryMenuType() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/menuType',
    method: 'get'
  });
}
function queryMenuTypeByGroupBuy() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/menuTypeByGroupBuy',
    method: 'get'
  });
}

// 获取满件数类型
function queryThresholdType() {
  return (0, _requestPIM.default)({
    url: requestUrl + '/thresholdType',
    method: 'get'
  });
}

// 商品搜索
function queryGoodsSearch(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/goodsSearch',
    method: 'get',
    params: query
  });
}

// 商品及规格搜索
function queryGoodsAndSpecSearch(query) {
  return (0, _requestPIM.default)({
    url: requestUrl + '/goodsSpecSearch',
    method: 'get',
    params: query
  });
}